import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './CheckBoxGroupInput.css'
import {asField} from '$src/common/forms'

interface Props {
  css?: any
  name: string
  label: string
  placeholder?: string
  value: any[]
  options: Array<{label: string; value: string; isActive: boolean}>
  onChange: (v: any) => void
  dataType?: boolean
}

interface State {}

@observer
export default class CheckBoxGroupInput extends Component<Props, State> {
  static Field: any

  constructor(props: Props, context: any) {
    super(props, context)
    this.state = {}
  }

  render() {
    const {props} = this
    const classes = resolveCss(css, props.css)
    const wholeValue = Array.isArray(props.value) ? props.value : []

    return (
      <div {...classes('container')}>
        <div {...classes('label')}>{props.label}</div>

        {props.options.map(({label, value, isActive}) => {
          const isOn: boolean = wholeValue.indexOf(value) !== -1

          return (
            <label
              key={`label-${value}`}
              {...classes('item', isOn ? 'on' : '')}
            >
              <input
                type="checkbox"
                key={`value-${value}`}
                checked={props.dataType ? isActive : isOn}
                onChange={() => {
                  if (isOn) {
                    props.onChange(wholeValue.filter(v => v !== value))
                  } else {
                    props.onChange(wholeValue.concat([value]))
                  }
                }}
              />
              <div className={css.itemLabel}>{label}</div>
            </label>
          )
        })}
      </div>
    )
  }
}
CheckBoxGroupInput.Field = asField()(CheckBoxGroupInput)



// WEBPACK FOOTER //
// ./src/common/CheckBoxGroupInput.tsx